<script setup lang="ts">
import { Skeleton as VarSkeleton, type SkeletonProps } from '@varlet/ui';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<SkeletonProps>();
</script>

<template>
  <VarSkeleton v-bind="props">
    <slot />
  </VarSkeleton>
</template>
